import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FeatureFlags from '../../../../../util/featureFlags';

import FoilNoneIcon from '../../../../../assets/images/invitations/foilNone.svg';
import FoilGoldIcon from '../../../../../assets/images/invitations/foilGold.svg';
import FoilRosegoldIcon from '../../../../../assets/images/invitations/foilRosegold.svg';
import FoilSilverIcon from '../../../../../assets/images/invitations/foilSilver.svg';
import lightbulb from '../../../../../assets/images/invitations/lightbulb.png';

// Styles
import styles from './styles.module.less';

const SORTED_FOIL = ['none', 'gold', 'copper', 'silver'];

const FOIL_DISPLAY = {
  none: {
    label: 'None',
    img: FoilNoneIcon,
  },
  gold: {
    label: 'Gold',
    img: FoilGoldIcon,
  },
  copper: {
    label: 'Rose Gold',
    img: FoilRosegoldIcon,
  },
  silver: {
    label: 'Silver',
    img: FoilSilverIcon,
  },
};

function sortFoil(availableFoil) {
  return SORTED_FOIL.map(foilKey => {
    return availableFoil.find(foilOption => foilOption.value === foilKey) || {};
  });
}

export default function FoilField({
  availableFoil,
  input: { onChange },
  activeFoilColor,
  pricing,
  printingTechnique,
}) {
  const [localActiveFoil, setLocalActiveFoil] = useState(activeFoilColor);
  const isFoilSelected = foil => {
    if (printingTechnique === 'CUSTOM_FOIL') {
      return localActiveFoil === foil.value;
    }
    return foil.value === 'none';
  };

  function onUpdate(foilVal) {
    if (!foilVal.enabled) {
      return null;
    }
    setLocalActiveFoil(foilVal.value);
    onChange(foilVal.value);
    return null;
  }

  // // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    setLocalActiveFoil(activeFoilColor);
  }, [activeFoilColor]);

  if (!availableFoil) {
    return null;
  }

  const sortedFoil = sortFoil(availableFoil);
  return (
    <div className={styles.foilField}>
      <div className={styles.foilMessageContainer}>
        <div className={styles.lightbulb}>
          <img src={lightbulb} alt="lightbulb" height="16" width="20" />
        </div>
        <div className={styles.foilMessage}>
          {FeatureFlags.get('freeCustomFoilEvent') ? (
            <>For a limited time, add foil to as many text boxes as you want for FREE.</>
          ) : (
            <>Add foil to as many text boxes as you want for only $0.65 per card.</>
          )}
        </div>
      </div>
      <ul className={styles.foilList}>
        {sortedFoil.map(each => (
          <li
            className={cx(styles.foilItem, {
              [styles.activeFoilItem]: isFoilSelected(each),
              [styles.disabledFoil]: !each.enabled,
            })}
            onClick={() => onUpdate(each)}
            key={each.value}
          >
            {isFoilSelected(each) && (
              <div className={styles.foilActive}>
                <i className="zolaicon zolaicon-checkmark" />
              </div>
            )}
            <div className={cx({ [styles.notActive]: !isFoilSelected(each) })}>
              <img
                className={styles.foilImage}
                src={FOIL_DISPLAY[each.value].img}
                alt={each.label}
                width="20"
                height="20"
              />
            </div>
            <div className={styles.foilLabel}>{FOIL_DISPLAY[each.value].label}</div>
            {each.value !== 'none' && pricing && !Number.isNaN(pricing[each.value]) && (
              <div className={styles.foilPrice}>
                {`+ $${(pricing[each.value] / 100).toFixed(2).toString()} Ea.`}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

FoilField.propTypes = {
  availableFoil: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.value,
      price: PropTypes.number,
      image: PropTypes.node,
    })
  ),
  input: PropTypes.shape({
    onChange: PropTypes.func,
  }),
  pricing: PropTypes.shape({}),
  activeFoilColor: PropTypes.string,
  printingTechnique: PropTypes.string,
};
